import React from 'react';

import styled from 'styled-components';

import { IBaseProps, OnClick } from '@rbi-ctg/frontend';
import { ISanityImage } from '@rbi-ctg/menu';
import { ClickableContainer } from 'components/clickable-container';
import { Picture } from 'components/picture';
import { brandFont } from 'styles/brand-font';
import { primitive } from 'styles/constants/primitives';
import { stylesForMaxLinesOfText } from 'utils/style/max-lines-text';

import { theme } from './theme';

const Container = styled(ClickableContainer)`
  display: flex;
  flex-direction: column;

  background-color: ${p => p.theme.token('background-pattern')};
  box-shadow: ${Styles.boxShadow};
  border-radius: 8px;
  padding: ${primitive.$spacing2};
  padding-block-end: ${primitive.$spacing3};
  cursor: pointer;
  outline: ${p => p.theme.cardOutline};

  &:hover {
    box-shadow: ${Styles.boxShadow}, ${Styles.boxShadow}, ${Styles.boxShadow};
  }
`;

const ImageContainer = styled.div<{ imageHeightWidthRatio: number }>`
  position: relative;
  width: 100%;
  height: 0;
  padding-block-end: ${p => p.imageHeightWidthRatio * 100}%;
  overflow: hidden;
  border-radius: 4px;
`;

const Image = styled(Picture)`
  position: absolute;
  inset-block-start: 0;
  inset-inline-start: 0;
  width: 100%;
  height: 100%;
`;
const Content = styled.div`
  flex: 1 1 auto;
  display: flex;
  flex-direction: column;
  width: 100%;
`;

interface ICard extends IBaseProps {
  backgroundImage?: ISanityImage;
  image: ISanityImage;
  imageAlt?: string;
  imageHeightWidthRatio?: number;
  onClick?: OnClick;
}

export const Card: React.FC<ICard> = ({
  image,
  backgroundImage,
  imageAlt,
  children,
  className,
  imageHeightWidthRatio = 0.75,
  onClick,
}) => {
  const handleKeyDown = (event: React.KeyboardEvent<HTMLDivElement>) => {
    if (event.key === 'Enter' || event.key === ' ') {
      event.preventDefault();
      onClick?.(event);
    }
  };

  return (
    <Container className={className} onClick={onClick} onKeyDown={event => handleKeyDown(event)}>
      <ImageContainer imageHeightWidthRatio={imageHeightWidthRatio}>
        {backgroundImage && <Image alt="" image={backgroundImage} />}
        <Image alt={imageAlt || ''} objectFitContain image={image} />
      </ImageContainer>
      <Content>{children}</Content>
    </Container>
  );
};

interface ITitle {
  useFullHeight?: boolean;
}
export const Title = styled.h3<ITitle>`
  margin: 0;

  text-transform: ${Styles.textTransform.headlines};
  font: ${brandFont.headerFour};
  letter-spacing: 1px;
  color: ${p => p.theme.token('text-default')};
  ${p =>
    stylesForMaxLinesOfText({
      maxLines: 3,
      lineHeight: theme.titleLineHeight,
      fontSizeInRem: 1,
      useFullHeight: p.useFullHeight,
    })}

  ${Styles.desktop} {
    ${(p: ITitle) =>
      stylesForMaxLinesOfText({
        maxLines: 3,
        lineHeight: theme.titleLineHeight,
        fontSizeInRem: 1.1,
        useFullHeight: p.useFullHeight,
      })}
  }
`;
